import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
`;

const progress = keyframes`
  from {
    width: 100%;
  }
  to {
    width: 0%;
  }
`;

export const ToasterContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: none;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    top: 10px;
    right: 10px;
    left: 10px;
  }
`;

export const Toast = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  box-shadow: ${({ theme }) => theme.shadows.xl};
  min-width: 300px;
  max-width: 400px;
  animation: ${slideIn} 0.3s ease-out;
  pointer-events: auto;
  position: relative;
  overflow: hidden;

  ${({ type, theme }) => {
    switch (type) {
      case 'success':
        return `
          border-left: 4px solid ${theme.colors.success};
        `;
      case 'error':
        return `
          border-left: 4px solid ${theme.colors.error};
        `;
      case 'warning':
        return `
          border-left: 4px solid ${theme.colors.warning};
        `;
      case 'info':
        return `
          border-left: 4px solid ${theme.colors.info};
        `;
      default:
        return `
          border-left: 4px solid ${theme.colors.primary};
        `;
    }
  }}

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    min-width: auto;
    max-width: none;
  }
`;

export const ToastIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex-shrink: 0;

  ${({ type, theme }) => {
    switch (type) {
      case 'success':
        return `
          background: ${theme.colors.successLight};
          color: ${theme.colors.success};
        `;
      case 'error':
        return `
          background: ${theme.colors.errorLight};
          color: ${theme.colors.error};
        `;
      case 'warning':
        return `
          background: ${theme.colors.warningLight};
          color: ${theme.colors.warning};
        `;
      case 'info':
        return `
          background: ${theme.colors.infoLight};
          color: ${theme.colors.info};
        `;
      default:
        return `
          background: ${theme.colors.primaryLight};
          color: ${theme.colors.primary};
        `;
    }
  }}

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ToastContent = styled.div`
  flex: 1;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: 1.4;
`;

export const ToastCloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.textTertiary};
  cursor: pointer;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  transition: all ${({ theme }) => theme.transitions.fast};
  flex-shrink: 0;

  &:hover {
    background: ${({ theme }) => theme.colors.backgroundTertiary};
    color: ${({ theme }) => theme.colors.textPrimary};
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ToastProgress = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background: ${({ type, theme }) => {
    switch (type) {
      case 'success':
        return theme.colors.success;
      case 'error':
        return theme.colors.error;
      case 'warning':
        return theme.colors.warning;
      case 'info':
        return theme.colors.info;
      default:
        return theme.colors.primary;
    }
  }};
  animation: ${progress} ${({ duration }) => duration}ms linear;
`;
